// Stil Reform – defaulta till "Bättre" per produkt (endast om ingen variant är vald)
(() => {
  // Default-variant per produkt-handle
  const betterByHandle = {
    "lagning": "53041437999437",
    "kortning-av-byxa": "53076155171149"
  };

  // Kör bara på produktsidor
  if (!window.location.pathname.includes("/products/")) return;

  // Hämta produkt-handle från URL
  const handle = window.location.pathname.split("/products/")[1]?.split("/")[0];
  if (!handle) return;

  // Finns ingen default för denna produkt: gör inget
  const betterId = betterByHandle[handle];
  if (!betterId) return;

  const url = new URL(window.location.href);
  const currentVariant = url.searchParams.get("variant");

  // Bara om det saknas variant i URL (första landningen)
  if (!currentVariant) {
    url.searchParams.set("variant", betterId);
    window.location.replace(url.toString());
  }
})();
